export const cellSizes = ['S', 'M', 'L', 'PP', 'XS'];
